import { Component } from '@theme/component';

class RangeCardsComponent extends Component {
	connectedCallback() {
		super.connectedCallback?.();

		this.track = this.querySelector('.range-cards__track');
		this.prevBtn = this.querySelector('.range-cards__arrow--prev');
		this.nextBtn = this.querySelector('.range-cards__arrow--next');

		if (this.track) {
			this.scrollToActive();
			this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
			this.updateArrows();
		}

		if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.scroll(-1));
		if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.scroll(1));
	}

	scrollToActive() {
		const active = this.querySelector('.range-cards__card--active');
		if (!this.track || !active) return;
		const pad = this.track.classList.contains('range-cards__track--peek')
			? this.track.clientWidth * 0.15
			: 0;
		const target = active.offsetLeft - this.track.offsetLeft - pad;
		this.track.scrollLeft = Math.max(0, target);
	}

	scroll(direction) {
		if (!this.track) return;
		const card = this.track.querySelector('.range-cards__card');
		if (!card) return;
		const scrollAmount = card.offsetWidth + 10; // card width + gap
		this.track.scrollBy({ left: direction * scrollAmount, behavior: 'smooth' });
	}

	updateArrows() {
		if (!this.track || !this.prevBtn || !this.nextBtn) return;
		const { scrollLeft, scrollWidth, clientWidth } = this.track;
		this.prevBtn.disabled = scrollLeft <= 1;
		this.nextBtn.disabled = scrollLeft + clientWidth >= scrollWidth - 1;
	}
}

if (!customElements.get('range-cards-component')) {
	customElements.define('range-cards-component', RangeCardsComponent);
}
